import { showCatalogPicker } from '../State/showCatalogPicker';

export default () => (dispatch) => {
    dispatch(showCatalogPicker());
}
